export default "__VITE_ASSET__CGVPxfuA__"